import styled from 'styled-components';

interface ISearchOption {
  align?: string;
}

export const SearchOptions = styled.div<ISearchOption>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;

  @media screen and (max-width: 768px) {
    & {
      padding: 0;
    }
  }
  .seperator {
    border-left: 1px solid var(--outline);
    height: 1rem;
    margin: 0 0.5rem;
  }
  &.border-bottom {
    border-bottom: 1px solid var(--outline);
  }
  &.setting-medical {
    padding: 0.5rem 1rem;
  }
  .px-75 {
    /* padding: 0.5rem 0.75rem; */
  }
  > button {
    height: 2.5rem;
    width: 6rem;
  }
  .searchData {
    display: flex;
    font-size: 0.875rem;
    align-items: center;
    padding: 0 1rem;
    border-radius: 0.25rem;
    background-color: var(--tonal);
    color: var(--text-secondary);
    min-width: 130px;

    > span {
      color: var(--text-disabled);
      margin-right: 0.5rem;
    }

    @media screen and (max-width: 1024px) {
      & {
        width: 100%;
        height: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .btn {
    width: 92px;

    .worker-search-btn {
      width: 100%;
    }
  }
  .searchResult {
    padding: 0 0.75rem;
    font-size: 0.875rem;
    background-color: var(--tonal);
    color: var(--text-secondary);
    height: 2.5rem;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    span {
      font-weight: 600;
      color: var(--text-primary);
      margin-left: 0.25rem;
      /* margin-right: 0.125rem; */
    }
  }
  .firstSearchOption {
    width: 100%;
    flex-shrink: 0;
    padding: 0.5rem;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    border-bottom: 1px solid var(--outline);
  }
  .inputsWrapperGroup {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    width: 100%;
    overflow: hidden;
    .icon-btn {
      flex-shrink: 0;
      width: fit-content;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
      gap: 0.25rem;
      cursor: pointer;
      border-radius: 5rem;
      padding-right: 1rem;
      padding-left: 0.5rem;
      font-size: 0.875rem;
      background-color: var(--tonal);
      color: var(--text-primary);
      &:hover {
        background-color: var(--tonal-deep);
      }
      > span {
        color: var(--text-primary);
      }
      &.arrow-icon span {
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
      }
    }
  }
  .inputsWrapper {
    width: 100%;
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    @media (max-width: 1024px) {
      flex-wrap: nowrap;
      overflow: auto;
      &::-webkit-scrollbar {
        height: 0rem;
      }
    }
    &.sensor-results {
      > div {
        flex-shrink: 0;
      }
    }
    .inputForm-cont {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      flex-wrap: wrap;
    }
    .inputForm-col {
      &.maxWidth-8 {
        input {
          width: 8rem;
        }
        &.maxWidth-10 {
          input {
            width: 10rem;
          }
        }
      }
    }
    .inputForm-row-w200 {
      width: 30rem;
    }
    .inputForm-row.withLabel {
      display: flex;
      align-items: center;
      background-color: var(--tonal);
      border-radius: 0.25rem;
      position: relative;
      label {
        font-size: 0.875rem;
        color: var(--text-secondary);
        padding: 0 0.75rem;
        user-select: none;
        font-weight: 600;
      }
      > div:nth-child(2) {
        background-color: var(--tonal);
        border-left: 1px solid var(--outline);
        border-radius: 0 0.25rem 0.25rem 0;
        :focus-within {
          background-color: var(--tonal);
        }
        > div > ul {
          position: static;
          > li:first-child {
            /* border-radius: 0; */
            outline: none;
          }
        }
      }
    }
    .inputForm-row {
      flex-shrink: 0;
    }
    .inputForm-row-fit {
      flex-shrink: 0;
      width: fit-content;
      height: 2.5rem;
      border-radius: 0.25rem;
      display: flex;
      align-items: center;
      background-color: var(--tonal);

      button.date-picker-btn {
        width: 2.5rem;
        height: 2.5rem;
        padding: 0;
        border-left: 1px solid var(--outline);
        background-color: var(--tonal);
        border-radius: 0;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;

        > span {
          font-size: 16px;
          color: var(--text-primary);
        }

        &:hover:not(:disabled),
        &:focus:not(:disabled) {
          background-color: var(--tonal-deep);
        }

        &:disabled {
          cursor: default;
          > span {
            color: var(--text-disabled);
          }
        }
      }

      .inputForm-col:focus-within {
        background-color: var(--tonal-deep) !important;
        > div > input {
          background-color: var(--tonal-deep) !important;
        }
      }

      &.notOutline:focus-within {
        outline: none;
      }
      span.calendarLabel {
        font-size: 0.875rem;
        padding: 0 0.75rem;
        user-select: none;
        color: var(--text-secondary);
        font-weight: 600;
      }
      span.calendarFooter {
        font-size: 0.875rem;
        padding-right: 0.75rem;
        padding-left: 0.25rem;
        user-select: none;
        color: var(--text-secondary);
        font-weight: 400;
      }
      > div:nth-child(2) {
        background-color: var(--tonal);
        border-left: 1px solid var(--outline);
        border-radius: 0 0.25rem 0.25rem 0;
        span.wave {
          color: var(--text-secondary);
        }
        :focus-within {
          background-color: var(--tonal);
        }
      }
    }
    input {
      background-color: var(--tonal);
    }
    input[type='text'] {
      height: 2.5rem;
      border-radius: 0.25rem;
      font-size: 0.875rem;
      font-weight: 500;
    }
    input#startInput,
    input#endInput,
    input#startInput2,
    input#endInput2 {
      height: 2.5rem;
      border-radius: 0.25rem;
      font-size: 0.875rem;
      width: 6rem;
      padding: 0;
      text-align: center;
      outline: none;
      font-weight: 500;
    }
    .inputDash {
      user-select: none;
      color: var(--text-secondary);
    }
    ul {
      height: 2.5rem;
    }
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
  .filter-btn {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.25rem;
    background-color: var(--tonal);
    :hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .sensorOverflow {
    overflow: initial;
    .secondSearchOption {
      /* overflow: initial; */
      overflow: auto;
    }
  }
  /* multiSelect */
  .basic-multi-select {
    .select__control {
      height: 40px;

      .select__value-container {
        flex-wrap: nowrap;
        height: 100%;
        padding: 0 3px;

        .select__placeholder {
          margin: 0 4px;
          padding: 0;
        }
        .select__input-container {
          margin: 0 4px;
          padding: 0;
        }
      }
    }
  }

  .filter-wrapper {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    gap: 0.5rem;

    @media screen and (max-width: 768px) {
      & {
        flex-direction: column;
        gap: 0.5rem;
        padding: 0.5rem 0;

        .inputsWrapper {
          width: 100%;
        }
      }

      .iconBtnGroup {
        justify-content: flex-end;
        width: 100%;
      }
    }

    .inputsWrapper {
      display: flex;
      align-items: center;
      width: auto;

      .iconBtnGroup {
        gap: 0.5rem;

        .filter {
          span {
            font-variation-settings: 'FILL' 0;
          }
        }
      }

      button {
        height: 2.5rem;
      }
    }
  }
  .filter-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 2.5rem;
    border: 1px solid var(--outline);
    padding: 0;

    &:focus {
      > span {
        color: var(--primary);
      }
    }
  }
`;
